import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { getUserState } from '@/firebase'
import LoginPage from '../views/Login.vue'
import UsermanagementPage from '../views/management/UserManagement.vue'
import GroupManagementPage from '../views/management/GroupManagement.vue'
import FourOFourPage from '../views/404.vue'
import FourOOnePage from '../views/401.vue'
import { useAuthStore } from '@/stores/auth'
import WarehouseReclamationSearch from '@/views/pages/warehouse/WarehouseReclamationSearch.vue'
import Accounting_WarehouseReclamationSearch from '@/views/pages/accounting/Accounting_WarehouseReclamationSearch.vue'
import CustomerServiceReclamationSearch from '@/views/pages/customerservice/CustomerServiceReclamationSearch.vue'
import Accounting_CustomerServiceReclamationSearch from '@/views/pages/accounting/Accounting_CustomerServiceReclamationSearch.vue'
import FollowUpdeliveries from '@/views/pages/warehouse/Followupdeliveries.vue'
import WikiPage from '@/views/wiki/WikiPage.vue'
import Export from '@/views/management/Export.vue'
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
      meta: {
        title: 'Home',
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: LoginPage,
      meta: {
        title: 'Login',
        requiresUnauth: true
      }
    },
    {
      path: '/warehouse/claims',
      name: 'warehouse/claims',
      component: WarehouseReclamationSearch,
      meta: {
        title: 'Lagerreklamationen',
        requiresAuth: true,
        category: "warehouse.view"
      }
    },    
    {
      path: '/accounting/warehouse/claims',
      name: 'accounting/warehouse/claims',
      component: Accounting_WarehouseReclamationSearch,
      meta: {
        title: 'Buchhaltung',
        requiresAuth: true,
        category: "accounting.warehouse.view"
      }
    },
    {
      path: '/customerservice/claims',
      name: 'customerservice/claims',
      component: CustomerServiceReclamationSearch,
      meta: {
        title: 'Kundenservicereklamationen',
        requiresAuth: true,
        category: "customerservice.view"
      }
    },
    {
      path: '/accounting/customerservice/claims',
      name: 'accounting/customerservice/claims',
      component: Accounting_CustomerServiceReclamationSearch,
      meta: {
        title: 'Buchhaltung',
        requiresAuth: true,
        category: "accounting.customerservice.view"
      }
    },
    {
      path: '/warehouse/followupdeliveries',
      name: 'warehouse/followupdeliveries',
      component: FollowUpdeliveries,
      meta: {
        title: 'Nachlieferungen',
        requiresAuth: true,
        category: "warehouse.followupdeliveries.view"
      }
    },
    {
      path: '/usermanagement',
      name: 'usermanagement',
      component: UsermanagementPage,
      props: true,
      meta: {
        title: 'Benutzermanagement',
        requiresAuth: true,
        category: "management.users"
      }
    },
    {
      path: '/groupmanagement',
      name: 'groupmanagement',
      component: GroupManagementPage,
      props: true,
      meta: {
        title: 'Gruppenmanagement',
        requiresAuth: true,
        category: "management.groups"
      }
    },
    {
      path: "/:pathMatch(.*)*",
      name: '404',
      component: FourOFourPage,
      meta: {
        title: '404',
        requiresAuth: true
      }
    },
    {
      path: "/401",
      name: '401',
      component: FourOOnePage,
      meta: {
        title: '401',
        requiresAuth: true
      }
    },
    {
      path: "/wiki",
      name: 'wiki',
      component: WikiPage,
      meta: {
        title: 'Wiki',
        requiresAuth: true
      }
    },
        {
      path: "/export",
      name: 'Export',
      component: Export,
      meta: {
        title: 'Exportieren',
        requiresAuth: true
      }
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  const isAuth = await getUserState()
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth)
  const requiresUnauth = to.matched.some((record) => record.meta.requiresUnauth)
  const requiresCategoryAccess = to.matched.some((record) => record.meta.category)

  document.title = 'Reklaverwaltung | ' + to.meta?.title ?? 'Reklaverwaltung'

  if (requiresAuth && !isAuth) next('/login')
  else if (requiresUnauth && isAuth) next('/')
  else if (requiresCategoryAccess && await useAuthStore().waitUntilInitialized() && !useAuthStore().hasUserAccessToCategory(to.meta.category)) next("/401")
  else next()
})

export default router
